import type { VoidFunctionComponent } from 'react';

import { isOrgInFreeTier } from '../../../../helpers/subscriptions';
import { Action, ResourceType, useHasPermission } from '../../../../shared/permissions';

import { SubscriptionBannerUpgradeWithDetails } from './SubscriptionBannerUpgradeWithDetails';

const SubscriptionBannerReportPage:VoidFunctionComponent = () => {
  const hasPermission = useHasPermission();
  const hasAccessToBilling = hasPermission({
    action: Action.Edit,
    resourceType: ResourceType.OrganizationBillingSettings,
  });
  const shouldDisplayBanner = (
    hasAccessToBilling &&
    isOrgInFreeTier()
  );

  if (!shouldDisplayBanner) {
    return null;
  }

  return <SubscriptionBannerUpgradeWithDetails />;
};

export default SubscriptionBannerReportPage;
